import React from "react";
import { MarkdownWithHighlightPowers } from "./MarkdownWithHighlightPowers";

// Memoized version of MarkdownWithHighlightPowers to prevent re-renders when rawMarkdownContent hasn't changed
export const MemoizedMarkdownWithHighlightPowers = React.memo(
  MarkdownWithHighlightPowers,
  (prevProps, nextProps) => {
    // Only re-render if the content has changed
    return prevProps.rawMarkdownContent === nextProps.rawMarkdownContent;
  }
);
